import type { EdgelessCanvasService } from '@/framework/services/canvas';
import type { IEdgelessTextLayer } from '../types';

/**
 * 从 Edgeless Canvas 获取真实 Text Layer 宿主。
 *
 * 这里只收窄宿主类型，不转发 renderer 的 layout/render 方法；调用方仍必须通过
 * `IEdgelessTextLayer` 的公开 seam 解析自己的最新候选数据。
 *
 * @param edgeless - 当前编辑器的 Edgeless Canvas 服务。
 * @param layerId - 真实 Text Layer 的图层 ID。
 * @returns 已注册的 Text Layer 宿主；宿主尚未创建时返回 null。
 */
export const getTextLayerHost = (edgeless: EdgelessCanvasService, layerId: string): IEdgelessTextLayer | null =>
    edgeless.getByLayerId(layerId) as IEdgelessTextLayer | null;
